export const SSO_LOGIN = 'sso/login';
export const CHECK_SUB_DOMAIN = 'user/checksubdomain';

export const SUBSCRIPTION_OVERVIEW = "subscription/overview";
export const GET_CUSTOMER_SUBSCRIPTION = "subscription/get-subscription";
export const MANAGE_PLANS = "subscription/manage-plans";
export const TRANSCTION_HISTORY = "subscription/transaction-history";
export const ADD_WALLET_AMOUMT = "wallet/add-money-wallet-customer";
export const CUSTOMER_INVOICES = "subscription/customer-invoice";
export const CLIENT_CONSUMPTION = "subscription/client-consumption";
export const MODIFY_SUBSCRIPTION = "subscription/customer-modify-subscription";
export const CHECK_CASHFREE_PAYMENT_SUCCESS = "secure/subscribe-payment-status";
export const RENEW_SUBSCRIPTION = "subscription/renew-subscription"
export const UPDATE_PAYMENT_STATUS = "subscription/update-payment-status"
export const UPDATE_ORG_BILLING_DETAILS = "subscription/update-billing-address";
export const GET_INVOICE_LIST = 'subscription/get-invoice-list'
export const GET_ORDER_STATUS = 'subscription/get-order-status'
export const GET_TRANSACTION_HISTORY = 'wallet/transaction-history'
export const GET_PLANS = 'plan/get-plans';
export const CALCULATE_CUSTOM_PLANS = 'plan/calculate-custom-plan';
export const CREATE_CUSTOM_PLANS = 'plan/create-custom-plan';

// helper apis
export const GET_COUNTRY_LIST = 'helper/get-country-list'
export const GET_STATE_LIST = 'helper/get-state-list'
export const GET_CITY_LIST = 'helper/get-city-list'


// form data
export const GET_ORG_FORM = 'user/get-org-form';
